import { render, staticRenderFns } from "./GenericBlock.vue?vue&type=template&id=4dd615ae"
import script from "./GenericBlock.vue?vue&type=script&lang=js"
export * from "./GenericBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports